import { clsx } from 'clsx'
import { TextAlignLeftIcon } from '@radix-ui/react-icons'
import descriptionStyles from './description.module.scss'
import { EventLayout } from '../branch-timeline'
import { PrimitiveTipTapEditor } from '~/lib/tiptap/components/primitive-editor'
import { getBranchCommentExtensions } from '~/lib/tiptap/extensions/branch-comment'
import { Branch } from '@basehub/data/replicache/index'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { useRepoUndoManager } from '~/replicache/frontend/undo-redo/manager'
import { useIsGuestInOthersBranch } from '~/hooks-data/use-user-role'

export const BranchDescription = ({ branch }: { branch: Branch }) => {
  const { data } = useRepoReplicache()
  const replicache = data?.replicache
  const undoManager = useRepoUndoManager()
  const isGuestInOthersBranch = useIsGuestInOthersBranch()

  return (
    <EventLayout date={new Date(branch.createdAt)} icon={<TextAlignLeftIcon />}>
      <PrimitiveTipTapEditor
        undo={{
          focusOp: undefined,
          manager: undoManager.current,
          persist: 'sessionStorage',
        }}
        className={clsx(descriptionStyles.editor, '-mt-0.5 pt-1.5')}
        value={branch.description ?? ''}
        instanceId={`branch-${branch.id}`}
        clientId={data?.clientId}
        onUpdate={async (update) => {
          await replicache?.mutate.updateBranch({
            id: branch.id,
            data: { description: update },
            isoNow: new Date().toISOString(),
          })
        }}
        readOnly={isGuestInOthersBranch}
        alwaysShowPlaceholder
        getExtensions={({ ...collab }) => {
          return getBranchCommentExtensions({
            collaborationExtensionsOptions: collab,
            readonly: isGuestInOthersBranch,
          })
        }}
      />
    </EventLayout>
  )
}
